<template>
  <div id="app">
    <NavBar v-if="!hideLayout" />
    <main :class="['main-container', { 'main-container--plain': hideLayout }]">
      <router-view />
    </main>
    <footer v-if="!hideLayout" class="site-footer">
      <div class="footer-inner">
        <div class="footer-brand">南京壹零壹陆信息科技有限公司</div>
        <p>© 2026 南京壹零壹陆信息科技有限公司 版权所有</p>
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏ICP备2026068411号</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: {
    NavBar
  },
  computed: {
    hideLayout() {
      const byMeta = Boolean(this.$route.meta && this.$route.meta.hideLayout)
      const routePath = this.$route.path || ''
      const byPath = routePath === '/bx1' || routePath.startsWith('/bx')
      return byMeta || byPath
    }
  },
  mounted() {
    this.$store.dispatch('fetchBanners')
    this.$store.dispatch('fetchPartners')
    this.$store.dispatch('fetchNews')
    this.$store.dispatch('fetchIndustry')
  }
}
</script>

<style>
:root {
  --n16-ink: #1e293b;
  --n16-muted: #64748b;
  --n16-line: #dbe4f0;
  --n16-bg: #f4f8fc;
  --n16-surface: #ffffff;
  --n16-brand: #0284c7;
  --n16-brand-soft: #e0f2fe;
  --n16-accent: #f43f5e;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  height: 100%;
}

body {
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Segoe UI", sans-serif;
  color: var(--n16-ink);
  background-color: var(--n16-bg);
}

a {
  color: inherit;
  text-decoration: none;
}

img {
  max-width: 100%;
  display: block;
}

.main-container {
  padding-top: 68px;
  min-height: calc(100vh - 120px);
}

.main-container--plain {
  padding-top: 0;
  min-height: 100vh;
}

.site-footer {
  background: #eef5fb;
  color: #64748b;
  padding: 16px;
  border-top: 1px solid #cfe0f0;
}

.footer-inner {
  max-width: 1120px;
  margin: 0 auto;
  text-align: center;
  font-size: 12px;
  line-height: 1.55;
}

.footer-brand {
  color: #0284c7;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 2px;
}

.footer-inner a {
  color: #0284c7;
}

.footer-inner a:hover {
  color: #f43f5e;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 11px 22px;
  border-radius: 999px;
  border: none;
  background: var(--n16-brand);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.btn-primary:hover {
  background: #0369a1;
  transform: translateY(-1px);
}

.section {
  padding: 64px 20px;
}

.section-inner {
  max-width: 1120px;
  margin: 0 auto;
}

.section-header {
  margin-bottom: 28px;
}

.section-title {
  font-size: 28px;
  color: var(--n16-ink);
  margin-bottom: 8px;
  font-weight: 700;
}

.section-subtitle {
  font-size: 12px;
  color: var(--n16-muted);
  max-width: 520px;
  line-height: 1.6;
}

.section-header--center {
  text-align: left;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.card {
  background: var(--n16-surface);
  border-radius: 16px;
  border: 1px solid var(--n16-line);
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(2, 132, 199, 0.12);
}

.card-body {
  padding: 20px 22px 24px;
}

.card-title {
  font-size: 17px;
  color: var(--n16-ink);
  margin-bottom: 8px;
  font-weight: 700;
}

.card-meta {
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 10px;
}

.card-text {
  font-size: 14px;
  color: var(--n16-muted);
  line-height: 1.75;
}

@media (max-width: 768px) {
  .main-container {
    padding-top: 60px;
  }

  .section {
    padding: 48px 16px;
  }

  .section-title {
    font-size: 22px;
  }

  .card-grid {
    grid-template-columns: 1fr;
  }
}
</style>
